import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { ButtonModule } from 'primeng/button';
import { CardModule } from 'primeng/card';
import { AutoCompleteModule } from 'primeng/autocomplete';
import { DropdownModule } from 'primeng/dropdown';
import { CommonModule } from '@angular/common';
import { FormBuilder, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { CalendarModule } from 'primeng/calendar';
import { InputTextModule } from 'primeng/inputtext';
import { InputTextareaModule } from 'primeng/inputtextarea';
import { TagModule } from 'primeng/tag';
import { SelectButtonModule } from 'primeng/selectbutton';
import { TableModule } from 'primeng/table';
import { FileUploadModule } from 'primeng/fileupload';
import { ToggleButtonModule } from 'primeng/togglebutton';
import { autocompleteSelectionValidator } from '../../../validators/non-async-validators';
import { ConfirmationService, MessageService } from 'primeng/api';
import { AddExpenseService } from '../../../services/add-expense.service';
import { AutocompleteService } from '../../../services/autocomplete.service';
import { catchError, debounceTime, distinctUntilChanged } from 'rxjs';
import { EntityType } from '../../../models/ConstantsAndEnums';
import { ExpenseApprovalViewModel } from '../../../models/ExpenseApprovalViewModel';
import { GenericButtonComponent } from '../../../../global/component/generic/generic-button/generic-button.component';


@Component({
  selector: 'expense-add-approvals',
  templateUrl: './expense-add-approvals.component.html',
  styleUrls: ['./expense-add-approvals.component.scss'],
  imports: [ButtonModule, CardModule, AutoCompleteModule, DropdownModule, CommonModule, CalendarModule, InputTextModule, InputTextareaModule, TagModule,
    SelectButtonModule, TableModule, FileUploadModule, ToggleButtonModule, ReactiveFormsModule, GenericButtonComponent],
  standalone: true,
  providers: [
    ConfirmationService,
    MessageService,
    AddExpenseService,
    AutocompleteService
  ],
})
export class ExpenseAddApprovalsComponent implements OnInit {
  expenseapproverForm!: FormGroup;
  @Input() campaignId!: number;
  @Input() expenseId!: number;
  @Input() expenseDetails: any;
  @Input() confirmAction!: (
    message: string,
    acceptCallback: () => void,
    rejectCallback?: () => void
  ) => void;
  @Output() prevCallback = new EventEmitter<void>();
  @Output() nextCallback = new EventEmitter<void>();
  @Output() errorEvent = new EventEmitter<string>();
  approverSuggestions: any = [];
  onIcon: string = 'pi pi-check-circle';
  approvers: ExpenseApprovalViewModel[] = [];

  constructor(private fb: FormBuilder, private addExpenseService: AddExpenseService, private autoCompleteService: AutocompleteService, private confirmationService: ConfirmationService) { }
  toggleInternalExpense(event: any) {
    this.addExpenseService.updateapprovalFlag(this.expenseId, event.checked? false: true).subscribe({
      next: () => {
      },
      error: () => {
        this.errorEvent.emit('Failed to update the approval flag');
      }
    });
  }

  ngOnInit(): void {
    this.initForm();
  }

  initForm() {
    this.expenseapproverForm = this.fb.group({
      internalExpense: [true],
      approver: ['']
    });
    this.addExpenseService.getApprovers(this.expenseId).subscribe({
      next: (data) => {
        if (data.length > 0) {
          this.approvers = data;
          this.expenseapproverForm = this.fb.group({
            internalExpense: [false],
            approver: ['']
          });
          this.expenseapproverForm.get('internalExpense')?.disable();
        }
        else {
          this.expenseapproverForm = this.fb.group({
            internalExpense: [true],
            approver: ['']
          });
        }
      },
      error: () => {
        this.errorEvent.emit('Failed to get approvers');
      }
    });

  }

  searchApprover(query: string): void {
    if (!query) {
      this.approverSuggestions = [];
      return;
    }
    this.autoCompleteService.getUserResults(query, this.campaignId, 0).pipe(
      debounceTime(300),
      distinctUntilChanged(),
      catchError(() => [])
    ).subscribe((results) => {
      console.debug(results);
      this.approverSuggestions = this.mapToLabelValue(results);
    });
  }

  onApproverSelect(approver: any) {
    const approverId = approver.value.value;
    this.addExpenseService.addApprover(this.expenseId, approverId).subscribe({
      next: (result) => {
        this.expenseapproverForm.get('approver')?.setValue('');
        this.addExpenseService.getApprovers(this.expenseId).subscribe({
          next: (data) => {
            this.expenseapproverForm.get('internalExpense')?.disable();
            this.approvers = data
          },
          error: () => {
            this.errorEvent.emit('Failed to get approvers');
          }
        });
      },
      error: (details) => {
        this.errorEvent.emit(details.error.userMessage ?? 'Failed to add approver');
      }
    });
  }

  deleteApprover(approver: any) {
    const expenseApprovalId = approver.expenseApprovalId;
    this.confirmAction?.('Are you sure you want to delete approver?',
      () => {
        this.addExpenseService.deleteApprover(expenseApprovalId).subscribe({
          next: (result) => {
            this.addExpenseService.getApprovers(this.expenseId).subscribe({
              next: (data) => {
                this.approvers = data;
                if (this.approvers && this.approvers.length > 0) {
                  this.expenseapproverForm.get('internalExpense')?.disable();
                }
                else {
                  this.expenseapproverForm.get('internalExpense')?.enable();
                }
              },
              error: () => {
                this.errorEvent.emit('Failed to get approvers');
              }
            });
          },
          error: () => {
            this.errorEvent.emit('Failed to add approver');
          }
        })
      },
      () => {  //Reject Functionality
      }
    );
  }
  private mapToLabelValue(items: any[]): { label: string, value: string }[] {
    return items?.map((item: any) => ({ label: item.name, value: item.id })) || [];
  }

  onSubmit() {
    this.nextCallback.emit();
  }
  onSaveExpense(): Promise<boolean> {
    return new Promise((resolve, reject) => {
      resolve(true);
    });
  }
}